import React, {Component} from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import LineChartContainer from 'containers/LineChartContainer'
import PropTypes from 'prop-types'

class ChartTabs extends Component {
	constructor (props) {
		super(props)
		this.state = {
			selectedIndex: 0,
			currency: props.currency
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.currency !== this.state.currency) this.setState({ selectedIndex: 0 })
	}

	render () {
		const { currency, mode } = this.props
		const selectedClassName = (mode === 'monetary') ? 'c-tabs__list__item--active--ebony' : 'c-tabs__list__item--active--cornflower'

		return <Tabs selectedIndex={this.state.selectedIndex} onSelect={tabIndex => this.setState({ selectedIndex: tabIndex, currency })} className='c-tabs u-center-on-mobile'>
			<TabList className='c-tabs__list o-list-bare o-list-inline'>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>1 сед</Tab>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>1 мес</Tab>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>3 мес</Tab>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>6 мес</Tab>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>1 год</Tab>
				<Tab className='c-tabs__list__item o-list-inline__item u-padding-small' selectedClassName={`c-tabs__list__item--active ${selectedClassName}`}>5 год</Tab>
			</TabList>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='week' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='month' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='threeMonths' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='sixMonths' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='year' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
			<TabPanel className='c-tabs__panel'>
				<LineChartContainer filter='fiveYears' currency={currency} mode={mode} {...this.props} />
			</TabPanel>
		</Tabs>
	}
}

ChartTabs.propTypes = {
	currency: PropTypes.number,
	mode: PropTypes.string
}

export default ChartTabs
